import React, { useContext, useState } from "react";
import { FaTimes } from "react-icons/fa";
import "../../styles/components-styles/sidebar-styles/UserProfileSidebar.css";
import { SidebarContext } from "../../contexts/SidebarContext";

function UserProfileSidebar() {
  const { toggleShowUserProfileSidebar, showUserProfileSidebar } =
    useContext(SidebarContext);
  const [darkMode, setDarkMode] = useState(false);

  const toggleDarkMode = () => setDarkMode(!darkMode);

  return (
    <div
      className={`user-profile-sidebar ${
        showUserProfileSidebar ? "open" : "closed"
      }`}
    >
      <div className="user-profile-sidebar-header">
        <span className="user-email">user@example.com</span>
        <FaTimes
          className="close-icon"
          onClick={toggleShowUserProfileSidebar}
        />
      </div>

      <ul className="user-profile-sidebar-list">
        {/* <li className="user-profile-sidebar-item">My resources</li>
                <li className="user-profile-sidebar-item">Install app</li>
                <li className="user-profile-sidebar-item">
                    Dark mode
                    <label className="user-profile-switch">
                        <input type="checkbox" checked={darkMode} onChange={toggleDarkMode} />
                        <span className="user-profile-slider"></span>
                    </label>
                </li>
                <li className="user-profile-sidebar-item">Settings</li>
                <li className="user-profile-sidebar-item">Messages</li> */}
        <li className="user-profile-sidebar-item">
          <a id="uslink" href="/dashboard/faq">FAQs</a>
        </li>
        <li className="user-profile-sidebar-item">
          <a id="uslink" href="/dashboard/subscribe">Suscribe</a>
        </li>
        <li className="user-profile-sidebar-item">
          <a id="uslink" href="/dashboard/contact">Contact us</a>
        </li>
        <li className="user-profile-sidebar-item">
          <a id="uslink" href="/">Log out</a>
        </li>
      </ul>
    </div>
  );
}

export default UserProfileSidebar;
